
import PreEntryApi from '../../assets/js/preentry'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'


export default {
components: {
XButton,
Group,
Cell,
XInput,
Loading,
Datetime,
XTextarea,
Confirm,
OnboardHeader
},
data () {
return {
id: '',
isZH: localStorage.getItem('offer_zh') === 'zh',
showLoading: true,
code: '',
mobileFlag: false,
offerUrl: {
1: 'onboard.white_offer', // 白领英文模板
8: 'onboard.white_offer', // 白领英文模板
2: 'onboard.blue_offer', // 蓝领模板
3: 'onboard.store_offer', // 店端模板
5: 'onboard.intern_offer', // 实习生模板
6: 'onboard.intern_blue_offer', // 实习生蓝领模板
7: 'onboard.intern_store_offer', // 实习生蓝领模板
9: 'onboard.social_intern_store_offer', // 实习生蓝领模板
10: 'onboard.white_offer_rsu', // 白领模板
11: 'onboard.blue_offer_elementary', // 蓝领S0-S3版本
12: 'onboard.school_offer', // 校招模板
13: 'onboard.school_offer_ssp', // 校招模板(含股权)
14: 'onboard.school_store_offer', // 店端校招模板（新）
15: 'onboard.school_offer_bj', // 校招模板 - 北京（确认落户）
16: 'onboard.school_offer_sh', // 校招模板 - 上海（确认落户）
17: 'onboard.school_offer_sale', // 校招模板 - 售后
18: 'onboard.school_offer_prod', // 校招模板 - 产品交付
19: 'onboard.school_offer_prod_sale', // 校招模板 - 产品专家（电销）
20: 'onboard.school_offer_bj_chj', // 校招模板 - 北京车和家汽车科技
21: 'onboard.school_offer_sh_lxqc', // 校招模板 - 上海理想汽车
22: 'onboard.blue_offer_elementary_joint', // 蓝领S0-S3版本 - 合资
23: 'onboard.white_offer_joint', // 白领无股权模板 - 合资
24: 'onboard.blue_offer_joint', // 蓝领S4-S9版本 - 合资
25: 'onboard.white_school_offer_stock', // 2023白领校招Offer Letter-含股权
26: 'onboard.white_school_offer', // 2023白领校招Offer Letter-不含股权
27: 'onboard.store_school_offer_sale', // 2023店端校招Offer Letter-电销&服务
28: 'onboard.store_school_offer_product', // 2023店端校招Offer Letter-产品交付&维修
29: 'onboard.white_school_offer_stock_rr', // 2022白领校招Offer Letter-含股权
30: 'onboard.white_school_offer_rr', // 2022白领校招Offer Letter-不含股权
31: 'onboard.store_school_offer_sale_rr', // 2022店端校招Offer Letter-电销&服务
32: 'onboard.store_school_offer_product_rr', // 2022店端校招Offer Letter-产品交付&维修
33: 'onboard.white_school_offer_xc', // 2023白领校招Offer Letter-四川理想新晨
34: 'onboard.white_school_offer_cdwl', // 2023白领校招Offer Letter-充电网络
35: 'onboard.white_school_offer_en', // 2023白领校招Offer Letter-不含股权（英文版）
36: 'onboard.white_school_offer_int_en', // 实习生offer模版（英文版）
37: 'onboard.school_sales_school', // 校企售后实习生offer

40: 'onboard.new_white_offer', // 白领模板
41: 'onboard.new_white_offer_en', // 白领英文模板
42: 'onboard.new_store_offer', // 店端offer
43: 'onboard.new_blue_offer', // 蓝领offer
44: 'onboard.new_intern_offer', // 实习offer
45: 'onboard.new_blue_research_offer', // 研发蓝领 offer
46: 'onboard.new_white_school_offer_stock', // 校招有股权 offer
47: 'onboard.new_white_school_offer', // 校招没股权 offer
48: 'onboard.new_white_school_offer_en', // 校招英文 不含股权 offer
49: 'onboard.new_store_school_offer', // 店端校招offer
50: 'onboard.new_white_school_charging_network_offer', // 白领校招充电网络
51: 'onboard.new_white_school_int_en_offer', // 校招实习生英文offer
52: 'onboard.new_blue_intern_offer', // 蓝领校企实习生
100: 'onboard.new_common_offer' // 公共模板
},
is_special_offer: 2,
offer_type: 0,
expectedGraduationTime: null,
startDate: null,
mobile: null,
schoolName: null,
lastMajor: null,
idCard: null,
email: null,
name: '',
campusRecruitment: null,
hrPreStaffStatus: null,
expectedGraduationTimeLess30Day: false
}
},
created () {
this.id = this.$route.query.id

this.mobileFlag = this.isMobile()


var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
(data, meta) => {
if (data && data.isSubmit === true && this.status !== 4) {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })

}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)
PreEntryApi.getStaffDetail({ id: this.id, code: this.code }, data => {
if (data) {
this.name = data.name ? data.name : data.candidate_name
this.is_special_offer = data.is_special_offer
this.offer_type = data.offer_type
this.expectedGraduationTime = data.expected_graduation_time
this.campusRecruitment = data.campus_recruitment_confirmation
this.hrPreStaffStatus = data.status
this.startDate = data.start_date
if (data.mobile) {
this.mobile = data.mobile
}
if (data.school_name) {
this.schoolName = data.school_name
}
if (data.last_major) {
this.lastMajor = data.last_major
}
if (data.id_card) {
this.idCard = data.id_card
}
if (data.email) {
this.email = data.email
}
this.showLoading = false
var endTime = new Date()
var startTime = data.expected_graduation_time.split('-')
startTime = new Date(startTime[0], startTime[1] - 1, startTime[2])
var datadiff = startTime.getTime() - endTime.getTime()
var time = 30 * 24 * 60 * 60 * 1000
if (datadiff < time) {
this.expectedGraduationTimeLess30Day = true
}
if (this.campusRecruitment === 1) {
this.$router.push({ name: 'onboard.thanks', query: { id: this.id } })
} else if (this.campusRecruitment === 2) {
this.$router.push({ name: 'onboard.campus_recruitment_refuse_success', query: { id: this.id } })
}
}
})
},
methods: {
goOffer () {

if (this.is_special_offer === 1) {
this.$router.push({
name: 'onboard.special_offer',
query: { id: this.id, back: 1 }
})
return false
}
this.$router.push({
name: this.offerUrl[this.offer_type],
query: { id: this.id, back: 1 }
})
return false
},
clear (type, key, val) {
if (val) {
this[type][key][val] = ''
} else {
this[type] = ''
}
},
isMobile () {
if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
return true
}
return false
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
},
campusRecruitmentConfirmation (status) {
if (status === 1) {
PreEntryApi.campusRecruitmentConfirmation({ id: this.id, code: this.code, campus_recruitment_confirmation: status }, (data) => {
if (status === 1) {
this.campusRecruitment = 1
this.$router.push({ name: 'onboard.thanks', query: { id: this.id } })
}
}, (data, message) => {
this.$message.error(this.$tsg(message))
})
} else {
this.$router.push({ name: 'onboard.campus_recruitment_refuse', query: { id: this.id } })
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/school_graduate.vue